export function objectToQueryString(obj) {
  return Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&");
}

/**
 * 校验手机号
 *
 * @export
 * @param {*} phone
 * @return {*}
 */
export function checkPhoneValid(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

/**
 * 校验邮箱
 *
 * @export
 * @param {*} email
 * @return {*}
 */
export function checkEmailValid(email) {
  return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email);
}

export const listToTree = function(list, parentKey, parentId = null) {
  const tree = [];
  for (const item of list.filter(i => i[parentKey] === parentId)) {
    const children = listToTree(list, parentKey, item.id);
    if (children.length) {
      item.children = children;
    }
    tree.push(item);
  }
  return tree;
};



// WEBPACK FOOTER //
// ./src/libs/utils.js